module.exports = __webpack_public_path__ + "img/empresa-01.4cb6f093.jpg";